import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { getWalletTxns } from "../Profile/UserEndpoints";
import { Table } from "antd";
import { ExtractDate, ExtractTime, getLocalStorageItem } from "../../Utils";
import { IoCaretBack } from "react-icons/io5";
import { useCommmonStore } from "../../Store/CommonReducer";
import { useNavigate } from "react-router-dom";
import { Images } from "../../Assets/Index";
import { getBetList } from "./MatchEndpoint";

const MyGameList = ({ game, gameType, startDate, endDate }) => {
  const [matchData, setMatchData] = useState([]);
  const { profileDetail } = useCommmonStore();
  const navigate = useNavigate();
  const getAllTxns = () => {
    getWalletTxns()
      .then((res) => {
        if (res.status) {
          setMatchData(res.data.data);
        }
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    getBetList(
      `game=${game}&gameType=${gameType}&start_date=${startDate}&end_date=${endDate}`
    )
      .then((res) => {
        if (res.status) {
          setMatchData(res.data);
        }
      })
      .catch((err) => console.log(err));
  }, []);
  const columns = [
    {
      title: "Bet Values",
      dataIndex: "bet_values",
      key: "bet_values",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          {data[0]}
        </p>
      ),
    },
    {
      title: "Bet Amount",
      dataIndex: "bet_amount",
      key: "bet_amount",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          ₹{data}
        </p>
      ),
    },
    {
      title: "Wining Amount",
      dataIndex: "winning_amt",
      key: "winning_amt",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          ₹{data}
        </p>
      ),
    },
    {
      title: "Bet Type",
      dataIndex: "bet_type",
      key: "bet_type",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          {data}
        </p>
      ),
    },
    {
      title: "Time",
      dataIndex: "createdAt",
      key: "createdAt",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          {ExtractDate(data)}.{ExtractTime(data)}
        </p>
      ),
    },
  ];
  return (
    <>
      <div className="flex justify-center  items-center bg-black rounded-lg">
        <div className="px-4 w-full rounded-lg h-screen bg-black">
          <AnimatePresence>
            <Table
              size="small"
              rowHoverable={false}
              columns={columns}
              // loading={isLoading}
              dataSource={matchData}
              className="w-screen sm:w-screen"
              // scroll={{
              //   y: 240,
              // }}
              pagination={false}
            />
          </AnimatePresence>
        </div>
      </div>
    </>
  );
};

export default MyGameList;
